import { Button, Col, Drawer, Row } from "antd";
import AIForm from "Pages/Consultation/AIForm/AIForm";
import { useEffect, useRef, useState } from "react";
import { CONSTANTS } from "utils/constant";
import Icons from "Common/Icons";
import VoiceRecognitionLoader from "Components/VoiceRecognitionLoader";
import HeaderTitle from "Pages/Consultation/AIForm/HeaderTitle";
import { IconMicAi, IconMicStop } from "Common/ReactIcons";
import LoadingDots from "Components/Customdotloader/LoadingDots";
import api from "utils/api";
import { CloseIcon } from "Common/ReactIcons";
import { IconMicMuted } from "Common/ReactIcons";
import { IconMic } from "Common/ReactIcons";
import { Close } from "Common/ReactIcons";
import { NewClose } from "Common/ReactIcons";
const AIFormDrawer = ({
  patient_last_name,
  patient_name,
  patient_id,
  patient_age,
  patient_gender,
  visible,
  toggleDrawer,
  apppointmentDetail,
  appointment_id,
  appointment_date_time,
  is_editable = true,
  chime_enabled = false,
  meetingData = {},
}) => {
  const [isSpeaking, setIsSpeaking] = useState(false);
  // const [showAIForm, setShowAIForm] = useState(false);
  const [showAIForm, setShowAIForm] = useState(false);
  const [creatingFBDocs, setCreatingFBDocs] = useState(false);
  const [showTrans, setShowTrans] = useState(false);
  const [transtext, setTransText] = useState("");
  const transcriptionDivRef = useRef(null);
  const handleStart = () => {
    // setIsSpeaking(true);
    setCreatingFBDocs(true);
    setShowAIForm(true);
    setTrancribe(true);
  };

  const handleFBDocFinish = () => {
    setIsSpeaking(true);
    setCreatingFBDocs(false);
  };

  const handleStop = () => {
    setIsSpeaking(false);
    setShowAIForm(false);
    setTrancribe(false);
  };
  const transModal = () => {
    setShowTrans((prev) => !prev);
  };
  // useEffect(() => {
  //   if (chime_enabled) handleStart();
  // }, []);
  useEffect(() => {
    if (transcriptionDivRef.current) {
      transcriptionDivRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [transtext]);
  function setTrancribe(set) {
    if (chime_enabled) {
      api.set_trancribe({
        meeting_id: meetingData?.MeetingId,
        action: set ? "start" : "stop",
      }).catch((err)=>{console.log(err);setIsSpeaking(false);});
    }
  }
  return (
    <>
      <Drawer
        // destroyOnClose={!chime_enabled}
        className="AI-form-drawer"
        contentWrapperStyle={
          chime_enabled && !visible
            ? { boxShadow: "none", display: "none" }
            : {}
        }
        mask={chime_enabled ? visible : true}
        title={
          <>
            {!chime_enabled && (
              <div className="sos-title conpsydrawer">
                <HeaderTitle
                  patientLastName={patient_last_name}
                  title={CONSTANTS.AI_FORM}
                  patientName={patient_name}
                  patientAge={patient_age}
                  patientGender={patient_gender}
                />
              </div>
            )}
          </>
        }
        width="55vw"
        placement="right"
        closable={false}
        // open={chime_enabled?visible:true}
        open={true}
        extra={
          <>
          {!chime_enabled && (
          <NewClose
            onClick={() => {
              toggleDrawer();
            }}
          />)}
          </>
        }
      >
        <>
          <div className="fetching-suggestion">
            <Row
              className="fetching-dictation"
              gutter={[24, 16]}
              justify="space-between"
              align="middle"
              style={{ height: "100%" }}
            >
              <Col flex="auto">
                <Row align="middle" justify="space-between">
                  {/* <Col
                    span={2}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <IconMicAi />
                  </Col> */}
                  <Col span={15}>
                    <div className="suggestion-full-content">
                      <div className="add-suggestion">
                        {/* Your voice data is being processed by AI assistant */}
                        AI is analyzing your voice data
                      </div>
                      <div>
                        <span
                          onClick={transModal}
                          className="view-transcription"
                        >
                          View Transcription
                        </span>
                      </div>
                      {/* <div className="save-suggestion">
                    Save the reviewed suggestions to DB
                  </div> */}
                    </div>
                  </Col>
                  <Col
                    span={6}
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      height: "30px",
                    }}
                  >
                    {isSpeaking ? (
                      // <div className="fetching-img-content">
                      //   <img
                      //     className="Fetching-voice-img"
                      //     src={Icons.AI_Fetching_data}
                      //   />
                      //   <div className="Fetching-voice">
                      //     Fetching the voice data...
                      //   </div>
                      // </div>
                      <VoiceRecognitionLoader />
                    ) : (
                      <></>
                    )}
                  </Col>
                </Row>
              </Col>
              {is_editable && (
                <Col>
                  {isSpeaking ? (
                    <Button className="stop-dictating" onClick={handleStop}>
                      <IconMicStop />
                      {/* <span>Stop Dictating</span> */}
                    </Button>
                  ) : (
                    <Button
                      className="start-dictation"
                      loading={creatingFBDocs}
                      onClick={handleStart}
                    >
                      Start
                      {/* <IconMic /> */}
                    </Button>
                  )}
                </Col>
              )}
              { chime_enabled &&<Col><NewClose
            onClick={() => {
              toggleDrawer();
            }}
          /></Col>
          }
            </Row>
          </div>
          <div className="transcription-content">
            {/* {transtext} */}
            {transtext.split(/(?<=\.|\?)/).map((sentence, index) => (
              <p key={index}>{sentence.trim()}</p>
            ))}
            {isSpeaking && <LoadingDots />}
            <div ref={transcriptionDivRef} />
          </div>
        </>

        <div>
          {/* <Row>
            <Col span={24}> */}
          <AIForm
            isSpeaking={isSpeaking}
            showAIForm={showAIForm}
            handleFBDocFinish={handleFBDocFinish}
            roomName={appointment_id}
            appointment_utc_date_time={appointment_date_time}
            patient_id={patient_id}
            is_editable={is_editable}
            showTrans={showTrans}
            transModal={transModal}
            chime_enabled={chime_enabled}
            setTransText={setTransText}
            transtext={transtext}
          />
          {/* </Col>
          </Row> */}
        </div>
      </Drawer>
    </>
  );
};

export default AIFormDrawer;
